/**
 * @description
 */

import './formNumberResultList.scss';

import React from 'react';

import FormRadioboxResultList, { IProps, IState } from '../@formRadioboxResultList/formRadioboxResultList';

export default class FormNumberResultList  extends FormRadioboxResultList {

    constructor(props: IProps, state: IState) {
        super(props, state);
    }

    public render() {
        return(
            <div className="form-option-reault-list number-option">
                {this.getOptionList()}
            </div>
        );
    }

    public getOptionImg = () => {
        return null;
    }

    public getItemOrder = () => {
        return '';
    }
}
